export default __webpack_public_path__ + "static/media/info.0b67b5fc.svg";